/** Ticker lines from feed items: the chosen fields of each item joined, the same way the server does for screens. */
export const newsItemsFrom = (items: Array<Record<string, string>>, fields: string[], joiner: string, maxItems: number): string[] =>
    items
        .map((item) => fields.map((f) => item[f] || '').filter(Boolean).join(joiner))
        .filter(Boolean)
        .slice(0, maxItems);
